import { AssertHomey } from '../../../../util/decorators';
import { card } from './card/store';

export const flow = {
	namespaced: true,

	state: {
		flows: null,
		folders: null,
		selected: null,
		subscribed: false,
	},

	getters: {
		selected(store){
			if (!(store.flows && store.selected)) return null;

			return store.flows.find(flow => flow.id === store.selected) || null;
		},
		structure(store){
			if (!(store.flows && store.folders)) return null;

			const structure = [];

			// Copy the folder values so we can add the children to them
			const folderCopy = Object.values(store.folders)
				.reduce((obj, folder) => ({ ...obj, [folder.id]: { children: [], ...folder } }), {});
			const folders = Object.values(folderCopy);

			// Add the flows to the corresponding folders
			store.flows.forEach(flow => {
				if (!flow.folder) {
					return structure.push(flow);
				}
				return folderCopy[flow.folder].children.push(flow);
			});
			// Add the folders to their parent folder
			folders.forEach(folder => {
				if (!folder.folder) {
					return structure.push(folder);
				}
				return folderCopy[folder.folder].children.push(folder);
			});

			// Sort the contents of the folders
			folders.forEach(folder => {
				folder.children = folder.children.sort((a, b) => a.order - b.order);
			});
			
			let result = [];
			//unpack everything
			let unpack = (list, indent) => {
    			list.forEach(item => {
        			item.level = indent;
        			result.push(item);
        			if(item.children) unpack(item.children, indent+1);
    			});
			};
			
			// Sort the content of the root structure array and unpack
			unpack(structure.sort((a, b) => a.order - b.order), 0);
			
			return result;
		},
		all(store){
			return store.flows;
		},
	},

	mutations: {
		setFlows(state, { flows, subscribe }){
			state.flows = flows;
            if(!state.subscribed) {
        		state.subscribed = true;
        		subscribe();
    		}
		},
		setFolders(state, { folders, subscribe }){
			state.folders = folders;
            if(!state.subscribed) {
        		state.subscribed = true;
        		subscribe();
    		}
		},
		select(state, { id }){
			state.selected = id;
		},
		clearAll(state){
			state.flows = null;
			state.folders = null;
			state.selected = null;
            state.subscribed = false;
		}
	},

	actions: {
		@AssertHomey()
		retrieveAll({ commit, homeyAPI }){
    		
            let refresh;
    		
    		let subscribe = () => {
        		homeyAPI.flow.on('flow.update', refresh);
        		homeyAPI.flow.on('flow.create', refresh);
        		homeyAPI.flow.on('flow.delete', refresh);
        		homeyAPI.flow.on('flowfolder.update', refresh);
        		homeyAPI.flow.on('flowfolder.create', refresh);
        		homeyAPI.flow.on('flowfolder.delete', refresh);
    		};
    		
    		refresh = async () => {
                return Promise.all([
    				homeyAPI.flow.getFlows()
    					.then((flows) => {
    						commit('setFlows', { flows: Object.values(flows), subscribe });
    					}),
    				homeyAPI.flow.getFlowFolders()
    					.then((folders) => {
    						commit('setFolders', { folders: folders, subscribe });
    					}),
    			]);
    		};
    		
    		return refresh();
		},
		clearAll({ dispatch, commit }){
			commit('clearAll');
			Object.keys(flow.modules).forEach(module => dispatch(`${module}/clearAll`));
		}
	},

	modules: {
		card,
	},

	plugins: [
		// (store) => {
		//   cloudAPI.on('logout', () => store.commit('api/logOut'));
		//   cloudAPI.on('token', (token) => store.commit('api/setToken', { token }));
		//
		//   const { token } = store.state.api;
		//   if (token) {
		//     store.dispatch('api/logIn', { token });
		//   }
		// },
	],
};
